// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Y_k9","row":"ProcedureTreatmentSummary_row__2QAbZ"};